
import { RootState } from '@/@types/store';
import { useDynamicDialog } from '@/hooks';
import { computed, defineComponent, onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex';

import { desensitization } from '@zto-sv/plugin/filters'
import { actionTypes, mutationTypes } from '@/store/types';
import { desMobile as desMobileFunc } from '@/utils/utilFuns'
import { CommonDialog } from '@/components/Common';
import _ from 'lodash';
import { ElMessageBox } from 'element-plus';
import { GetMerchantInfo, MerchantSheetQueryBySlaveAdmin, SlaveUserUnBind } from '@/api-server/modules/defaultServer';

export default defineComponent({
  components: { CommonDialog },
  setup() {
    const store = useStore<RootState>()
    const { getModelUUID, openModel } = useDynamicDialog();
    const visible = ref(false)
    const allPartnerIds = ref<BUSINESS_SERVE_PLATFORM_PC.MerchantSheetQueryBySlaveAdminResponseDataItem[]>([])

    const defaultProps = {
      children: "childMenus",
      label: "menuName",
      disabled: "disabled"
    };

    const desMobile = computed(() => {
      let mobile = ''
      try {
        mobile = desMobileFunc(store.state.user.userInfo.mobile)
      } catch(e) {
        mobile = ''
      }
      return mobile
    })
    const desEmail = computed(() => {
      let email = ''
      try {
        email = desensitization(store.state.user.userInfo.email)
      } catch(e) {
        email = ''
      }
      return email
    })
    const myRoles = computed(() => store.state.user.userInfo.menuRoleInfoCO.roleCOList.map(v => v.roleName))
    const isSuperAdmin = computed(() => store.getters["user/isSuperAdmin"]);
    const masterPhone = computed(() => store.getters["user/masterPhone"]);
    const menuInfoList = computed(() => setDisabled(store.state.config.menuInfoList))
    const defaultMenuCodeList = computed(() => store.state.user.userInfo.menuRoleInfoCO.menuCodeList)
    const partnerIdList = computed(() => {
      return allPartnerIds.value.filter( v => store.state.user.userInfo.menuRoleInfoCO.queryUserExist.partnerIdList?.includes(v.partnerId as string))
    })
    
    function setDisabled(list: any[]) {
      return _.cloneDeep(list).map(v => {
        v.disabled = true
        if (v.childMenus) {
          const childMenus = setDisabled(v.childMenus)
          v.childMenus = childMenus
        }
        return v
      })
    }
    
    async function openUserSettingDialog(cpPath: string, props: Record<string, unknown>, updateCallBack: (...args: unknown[]) => void) {
      const uuid = await getModelUUID(cpPath)
      openModel(
        uuid,
        props ? props : {},
        {
          updateSuccess: updateCallBack,
        }
      );
    }

    function updateMobileCallBack({ new_mobile }: { new_mobile: string }) {
      store.commit(`user/${mutationTypes.SET_USER_INFO}`, {
        ...store.state.user.userInfo,
        mobile: new_mobile
      })
    }

    function updateEmailCallBack({ new_email }: { new_email: string }) {
      store.commit(`user/${mutationTypes.SET_USER_INFO}`, {
        ...store.state.user.userInfo,
        email: new_email
      })
    }

    async function handleUnbind() {
      await ElMessageBox.confirm(
        "解绑后您在组织内的权限将全部被收回，请确认是否继续解绑操作？",
        "解绑",
        {
          cancelButtonText: "取消",
          confirmButtonText: "确定",
          type: "warning"
        }
      );
      await SlaveUserUnBind.fetch({})
      store.dispatch(`user/${actionTypes.GET_USER_INFO}`)
    }

    function handleShowPers() {
      visible.value = true
    }

    onMounted(async () => {
      const {
        data: { data },
      } = await MerchantSheetQueryBySlaveAdmin.fetch({});
      allPartnerIds.value = data as BUSINESS_SERVE_PLATFORM_PC.MerchantSheetQueryBySlaveAdminResponseDataItem[];
    })

    return {
      store,
      desMobile,
      desEmail,
      updateMobileCallBack,
      openUserSettingDialog,
      updateEmailCallBack,
      handleUnbind,
      myRoles,
      masterPhone,
      isSuperAdmin,
      handleShowPers,
      visible,
      defaultMenuCodeList,
      defaultProps,
      menuInfoList,
      setDisabled,
      partnerIdList,
    }
  },
})
